export const GET_PERFORMANCE_TRACKER_LIST = "GET_PERFORMANCE_TRACKER_LIST";
export const PERFORMANCE_TRACKER_LIST = "PERFORMANCE_TRACKER_LIST";

export const SEARCH_PERFORMANCE_TRACKER_BY_ID = "SEARCH_PERFORMANCE_TRACKER_BY_ID";
export const PERFORMANCE_TRACKER_BY_ID = "PERFORMANCE_TRACKER_BY_ID";

export const SAVE_PERFORMANCE_TRACKER = "SAVE_PERFORMANCE_TRACKER";
export const SAVE_PERFORMANCE_TRACKER_RESP = "SAVE_PERFORMANCE_TRACKER_RESP"

export const DELETE_PERFORMANCE_TRACKER = "DELETE_PERFORMANCE_TRACKER";
export const DELETE_PERFORMANCE_TRACKER_RESP = "DELETE_PERFORMANCE_TRACKER_RESP";

export const SEARCH_PERFORMANCE_TRACKER_BY_FIELD = "SEARCH_PERFORMANCE_TRACKER_BY_FIELD";
export const PERFORMANCE_TRACKER_BY_FIELD_LIST = "PERFORMANCE_TRACKER_BY_FIELD_LIST";
